import React from 'react';

export default function Card({ title, subtitle, children, className = '' }) {
	return (
		<div className={`bg-white rounded-lg shadow border border-gray-100 ${className}`}>
			{(title || subtitle) && (
				<div className="px-4 py-3 border-b">
					{title && <h3 className="text-base font-semibold">{title}</h3>}
					{subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
				</div>
			)}
			<div className="p-4">{children}</div>
		</div>
	);
}


